import React from 'react';
import PropTypes from 'prop-types';

import {Card, CardContent} from '@mui/material';
import { styled } from '@mui/material/styles';
import FilterableCardHeader from './FilterableCardHeader';

const FilterableCard = ({
  children,
  excludable,
  headerText,
  toolTip,
  item,
  onSwitchChange,
}) => {
  const exc = excludable || false;
  const ht = headerText || 'Filterable Section';
  const bc = '#fff';

  const CardContentFixPadding = styled(CardContent)(`
    &:last-child {
      padding-bottom: 7px;
    }
  `);

  return (
    <Card
      sx={{
        backgroundColor: bc,
        paddingLeft: 0,
        paddingRight: 0,
        marginBottom: '10px',
        minWidth: '368px',
        ':last-child': {
          paddingBottom: '3px !important',
        },
        border: '2px solid',
        borderColor: 'grayscale.lightest',
        boxShadow:'none'
      }}
    >
      <FilterableCardHeader excludable={exc} content={ht} toolTip={toolTip} id={item?.id} onSwitchChange={onSwitchChange}></FilterableCardHeader>
      <CardContentFixPadding sx={{ paddingTop: '7px' }}>
        {children}
      </CardContentFixPadding>
    </Card>
  );
};

FilterableCard.propTypes = {
  children: PropTypes.node.isRequired,
  excludable: PropTypes.bool,
  headerText: PropTypes.string.isRequired,
  toolTip: PropTypes.string,
  item: PropTypes.object,
  onSwitchChange: PropTypes.func,
};

export default FilterableCard;
